import React, {useContext, useEffect} from 'react';
import {Button} from 'antd';
import DeleteComponent from '../common/DeleteComponent';
import EditComponent from '../common/EditComponent';
import {Arguments} from '../common/Arguments';
import {sideMenuContext} from '../../../router/IndexRouter';
import {GetApiMethod} from '../common/ApiMethod';
import TableComponent from '../common/TablePaginationComponent';

export default function BranchActivity(props) {
	const currentUrl = window.location.href;
	const {dataSource, setDataSource, setCopyDataSource} = useContext(sideMenuContext);
	const getApi = Arguments.host + '/society_organization/base/branch/api!branchActivity.do';

	useEffect(() => {
		setDataSource([]);
		GetApiMethod({getApi, setDataSource, setCopyDataSource});
	}, [getApi]);

	const columns = [
		{
			title: '序号',
			dataIndex: 'showIndex',
			width: 90,
			sorter: (a, b) => a.showIndex - b.showIndex,
			sortDirections: ['ascend', 'descend'],
		},
		{
			title: '活动主题',
			dataIndex: 'activityName',
			width: 220,
		},
		{
			title: '主持人',
			dataIndex: 'activityCompere',
			width: 100,
		},
		{
			title: '活动时间',
			dataIndex: 'activityDate',
			width: 100,
			sorter: (a, b) => new Date(a.activityDate) - new Date(b.activityDate),
			sortDirections: ['ascend', 'descend', 'ascend'],
		},
		{
			title: '活动地点',
			dataIndex: 'activityAddress',
			width: 220,
		},
		{
			title: '活动类别',
			responsive: ['lg'],
			dataIndex: 'activityForm',
			width: 100,
		},
		{
			title: '参加人数',
			dataIndex: 'activityScope',
			width: 100,
		},
		{
			title: '操作',
			width: 140,
			render: (item) => (
				<>
					<EditComponent item={item} url={currentUrl}/>
					<DeleteComponent
						item={item}
						postApi={[Arguments.host + '/society_organization/base/branch/api!addBranchActivity.do']}
						getApi={getApi}
					/>
				</>
			),
		},
	];

	const indexDataSource = dataSource.map((data, index) => ({showIndex: index + 1, ...data}));

	return (
		<>
			<Button type="primary" onClick={() => props.history.push('/activity/branch-activities/add')}
					style={{marginBottom: 10}}>新增</Button>
			<TableComponent dataSource={indexDataSource} columns={columns}/>
		</>
	);
}


